"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialRootState = void 0;

var index_1 = require("../action-definitions/index");

var sort_types_1 = require("../types/sort.types");

exports.initialRootState = {
  instanceId: 'CHONKY_INVALID_ID',
  externalFileActionHandler: null,
  rawFileActions: [],
  fileActionsErrorMessages: [],
  fileActionMap: {},
  fileActionIds: [],
  toolbarItems: [],
  contextMenuItems: [],
  rawFolderChain: null,
  folderChainErrorMessages: [],
  folderChain: [],
  rawFiles: [],
  filesErrorMessages: [],
  fileMap: {},
  fileIds: [],
  cleanFileIds: [],
  sortedFileIds: [],
  hiddenFileIdMap: {},
  displayFileIds: [],
  focusSearchInput: null,
  searchString: '',
  searchMode: 'currentFolder',
  selectionMap: {},
  disableSelection: false,
  fileViewConfig: index_1.ChonkyActions.EnableGridView.fileViewConfig,
  sortActionId: null,
  sortOrder: sort_types_1.SortOrder.ASC,
  optionMap: {},
  thumbnailGenerator: null,
  doubleClickDelay: 300,
  disableDragAndDrop: false,
  clearSelectionOnOutsideClick: true,
  lastClickIndex: null,
  contextMenuMounted: false,
  contextMenuConfig: null
};